module.exports = __webpack_public_path__ + "static/media/Jaime Lannister 1.6723d4b5.jpg";